type FieldTag = { id: string; name: string; color: string | null };
export type FieldTagGroups = {
  customerTags?: FieldTag[];
  locationTags?: FieldTag[];
  jobTags?: FieldTag[];
};

export function FieldTags({ customerTags = [], locationTags = [], jobTags = [] }: FieldTagGroups) {
  return <>{([
    ["Customer tags", customerTags], ["Location tags", locationTags], ["Job tags", jobTags],
  ] as const).map(([label, tags]) => tags.length ? <span key={label} aria-label={label} className="mt-2 flex flex-wrap items-center gap-1.5 text-xs">
    <span className="font-medium text-slate-600">{label}</span>
    {tags.map(tag => <span key={tag.id} className="inline-flex max-w-full items-start gap-1.5 rounded-xl border border-slate-300 bg-white px-2 py-1 text-slate-800">
      <span aria-hidden="true" className="mt-1 h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: tag.color || "#64748b" }} />
      <span className="min-w-0 whitespace-normal break-words">{tag.name}</span>
    </span>)}
  </span> : null)}</>;
}
